import client from './client';

export interface Branding {
  org_id: string;
  logo_url: string | null;
  accent_color: string | null;
  display_name: string | null;
  print_footer: string | null;
}

export interface OrgHealthRow {
  org_id: string;
  org_name: string;
  org_title: string | null;
  is_active: boolean;
  user_count: number;
  company_count: number;
  mssql_host: string | null;
  mssql_user: string | null;
  mssql_configured: boolean;
}

export async function getBranding(): Promise<Branding> {
  const r = await client.get<Branding>('/org/branding');
  return r.data;
}

export async function putBranding(body: {
  logo_url?: string | null;
  accent_color?: string | null;
  display_name?: string | null;
  print_footer?: string | null;
}): Promise<Branding> {
  const r = await client.put<Branding>('/org/branding', body);
  return r.data;
}

export async function opsHealth(): Promise<OrgHealthRow[]> {
  const r = await client.get<OrgHealthRow[]>('/org/ops/health');
  return r.data;
}
